import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back\">\n<path d=\"M7 12L19 12\" stroke=\"#424242\" stroke-width=\"2\" stroke-linecap=\"square\" />\n<path d=\"M10 6L5 12L10 18\" stroke=\"#424242\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol